import { render } from "./TanaoroshiAdjustmentHistoryPage.vue?vue&type=template&id=40dc96a1"
import script from "./TanaoroshiAdjustmentHistoryPage.vue?vue&type=script&lang=js"
export * from "./TanaoroshiAdjustmentHistoryPage.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1513569783/src/hybrid_inventory_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__